import { Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { getViewer } from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import Settings from "settings";
import { userLoginToken } from "utils/general-utils";
import { VIEWER_QUERY } from "components/auth/query";

const getRequestedPath = (path:string):string => {

  /* Get the requestedPath from localStorage which is set in
  ui/src/components/auth/authorize-for-role.tsx and remove it from localStorage
  to prevent navigating to it in the future. */
  const requestedPath = localStorage.getItem("requestedPath");
  localStorage.removeItem("requestedPath");

  // Return the param path if requested path is not set
  if (!requestedPath) {
    return path;
  }

  return requestedPath;
};

const Home: React.FC = () => {
  const isLoggedIn = typeof userLoginToken() === "string";
  const { loading, error, data } = useQuery<getViewer>(VIEWER_QUERY, {
    fetchPolicy: "cache-and-network",
    skip: !isLoggedIn,
  });

  useEffect(() => {
    if (!isLoggedIn && Settings.env === "production") {
      window.location.assign("https://www.havenconnect.com");
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    if (loading) return <LoadingSpinner />;
    if (error || !data || data.viewer === null) return <div>Error loading user</div>;

    if (data.viewer.isAdmin) {
      return <Navigate to={getRequestedPath("/dash/admin")} replace />;
    } else if (data.viewer.isClient) {
      return <Navigate to={getRequestedPath("/dash/client/submissions")} replace />;
    } else if (data.viewer.isSupervisor || data.viewer.isPropManager) {
      return <Navigate to={getRequestedPath("/dash/manager/lists")} replace />;
    }
    return null;
  }

  if (Settings.env === "production") {
    return null; // Redirect handled by useEffect
  }

  return <Navigate to="/login" replace />;
};

export default Home;
